
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import BookingHero from './components/BookingHero';
import BookingForm from './components/BookingForm';
import BookingInfo from './components/BookingInfo';

export default function BookPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <BookingHero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <BookingForm />
          <BookingInfo />
        </div>
      </div>
      <Footer />
    </div>
  );
}